// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m91wug{overflow-y:auto}\n._19bv12x7{padding-left:var(--ds-space-075,6px)}\n._1fjgglyw{scrollbar-width:none}\n._1ke8idpf::-webkit-scrollbar{width:0}\n._1reo15vq{overflow-x:hidden}\n._1suq1j28::-webkit-scrollbar{background-color:transparent}\n._c71l1osq{max-height:100%}\n._ca0q12x7{padding-top:var(--ds-space-075,6px)}\n._n3td12x7{padding-bottom:var(--ds-space-075,6px)}\n._yv0e5bpd{grid-template-columns:auto 1fr}", ""]);
// Exports
module.exports = exports;
